iScreenWizard.directive('menuToggle', [ '$timeout', function($timeout){
	return {
		scope: {
			section: '=',
			toggleSidebar: '=togglesidebar'
		},
		templateUrl: 'partials/menu-toggle',
		link: function($scope, $element) {
			var controller = $scope.$parent;

			$scope.userService = controller.userService;

			$scope.isOpen = function() {
				return controller.isOpen($scope.section);
			};
			$scope.toggle = function() {
				controller.toggleOpen($scope.section);
			};
		}
	};
}]);